// PLUGINS IMPORTS //
import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components/macro'

// COMPONENTS IMPORTS //
import Header from './Header/Header'
import Body from './Body/Body'
import Footer from 'Content/Shared/Layout/Footer/Footer'

import Loading from 'Content/Shared/Components/Sections/Variables/Loading'
import Unfound from 'Content/Shared/Components/Sections/Variables/Unfound'
import ContactSection from 'Content/Shared/Components/Sections/ContactsSection/ContactsSection'

import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //
import { GlobalStyles } from 'Content/Shared/Styles/Theme'

// REDUX
import { getProjectInfoThunkCreator } from 'Redux/Reducers/ProjectsReducer'
import {
  getProjectInfoSelector,
  getProjectLoadingStateSelector,
} from 'Redux/Selectors/ProjectsSelectors'

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  routeProps: any
}

const ProjectScreen: React.FC<PropsType> = (props) => {
  const { ID } = useParams<{ ID: string }>()
  const project = useSelector(getProjectInfoSelector)
  const isLoading = useSelector(getProjectLoadingStateSelector)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getProjectInfoThunkCreator(ID))
  }, [])

  if (isLoading) {
    return <Loading />
  } else if (project && Object.values(project).length > 0) {
    return (
      <>
        <Wrapper>
          <Container>
            <Header project={project} />
            <Body project={project} />
          </Container>
        </Wrapper>
        <ContactsWrap>
          <ContactSection />
        </ContactsWrap>
        <Footer />
      </>
    )
  } else {
    return <Unfound />
  }
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${GlobalStyles.insets.pageTop}px;
`

const Container = styled.div`
  width: 70%;
`

const ContactsWrap = styled.div`
  margin-top: 120px;
  margin-bottom: -100px;
`

export default React.memo(ProjectScreen, memoComparison)
